export const PBBHTTPHeaders = {
  requestId: 'x-k-request-id',
  correlationId: 'x-k-correlation-id',
  maxShippingAddress: 'x-pbb-max-shipping-address',
  deviceRef: 'x-k-device-ref',
  accentlanguage: 'Accept-Language',
};
